import { useEffect, useState } from "react";
import { RotateCcw } from "lucide-react";
import { timeAgo } from "../utils/time";

/**
 * Reloads one screen's data without a browser refresh, and says how fresh it is.
 * Props: onRefresh(), loading, updatedAt (Date | ISO string).
 */
function RefreshButton({ onRefresh, loading = false, updatedAt = null, className = "" }) {
  const [now, setNow] = useState(() => Date.now());

  // Re-render the "updated Xs ago" label every 5 seconds.
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 5000);
    return () => clearInterval(id);
  }, []);

  const label = timeAgo(updatedAt, now);

  return (
    <div className={`inline-flex items-center gap-2 ${className}`}>
      {label ? (
        <span className="text-[11px] text-gray-400 whitespace-nowrap" aria-live="polite">
          {loading ? "Updating…" : `Updated ${label}`}
        </span>
      ) : null}
      <button
        type="button"
        onClick={onRefresh}
        disabled={loading}
        title="Refresh"
        aria-label="Refresh"
        className="rounded-lg border border-gray-200 p-1.5 text-gray-500 hover:bg-gray-50 hover:text-gray-800 disabled:cursor-wait dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800"
      >
        <RotateCcw className={`h-4 w-4 ${loading ? "animate-spin [animation-direction:reverse]" : ""}`} />
      </button>
    </div>
  );
}

export default RefreshButton;
